import { render, staticRenderFns } from "./PacklistHeader.vue?vue&type=template&id=df181d0a"
import script from "./PacklistHeader.vue?vue&type=script&lang=js"
export * from "./PacklistHeader.vue?vue&type=script&lang=js"
import style0 from "./PacklistHeader.vue?vue&type=style&index=0&id=df181d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports